export default __webpack_public_path__ + "static/media/story-icon.8d1b45a5.svg";